import React, { Component } from 'react';
import { Button, Heading, Box } from 'rebass';
import { Input } from 'reakit';
import styled from 'styled-components';

const StyledInput = styled(Input)`
	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
	width: 400px;
`;

class NewCategoryForm extends Component {
	state = {
		name: ''
	}

	handleInputChage = e => {
		this.setState({
			name: e.target.value
		});
	};

	handleSubmit = () => {
		this.props.onSubmit(this.state.name);
		this.setState({
			name: ''
		});
	};

	render() { 
		const { name } = this.state;
		const { toggleOverlay } = this.props;
		return (
			<Box>
				<Heading mb={2}>New Category</Heading>
				<Box mb={3}>
					<Button
						mr={2}
						bg={name.length === 0 ? 'meta' : 'green'}
						disabled={name.length === 0}
						onClick={this.handleSubmit}>
							Save
					</Button>
					<Button onClick={() => toggleOverlay()}>Cancel</Button>
				</Box>
				<Heading as={'h5'} mb={2}>Name</Heading>
				<StyledInput value={name} onChange={this.handleInputChage} />
			</Box>
		);
	}
}
 
export default NewCategoryForm;